<script setup>
const props = defineProps({
    item: {
        type: Object,
        required: true,
    }
});

const piecesText = window.Drupal.t('pieces');

const currencyFormatter = (value) => {
    return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(value / 100);
}
</script>

<template>
    <div class="vue-mini-cart-item">
        <div class="row">
            <div class="col-3">
                <img :src="item.translation?.image" :alt="item.translation.name">
            </div>
            <div class="col-9">
                <div class="row">
                    <div class="col-12">
                        <p class="font-weight-bold">{{ item.translation.name }}</p>
                    </div>
                </div>

                <div class="row d-flex align-items-center meta-info">
                    <div class="col-6 pieces">
                        <span>{{ item.quantity }} {{ piecesText }}</span>
                    </div>

                    <div class="col-6 price text-right">
                        {{ currencyFormatter(item.total_unit_price) }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>